
import Vue from 'vue'
import { PalletType, RateCard, ServiceLevel } from "@/models/rate_card_models";
import axios from "axios";

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';

const RATE_CARDS_URL = `${BASE_URL}/rate-cards/rate-cards`;
const SERVICE_LEVELS_URL = `${BASE_URL}/rate-cards/service-levels`;
const PALLET_TYPES_URL = `${BASE_URL}/rate-cards/pallet-types`;
const PRICING_URL = `${BASE_URL}/rate-cards/price-job/`;

const POSTCODE_REGEX = /^[A-Z]{1,2}[0-9]+/
export default Vue.extend({
  name: "PriceComparison",
  data() {
    return {
      rateCards: [] as RateCard[],
      palletTypes: [] as (PalletType & { count: number })[],
      serviceLevels: [] as ServiceLevel[],
      service: "",
      postcode: "",
      chosenRateCards: [{ rateCard: null, cost: null }, { rateCard: null, cost: null }] as ({
        rateCard: string | null,
        cost: number | null
      })[],
    };
  },
  async mounted() {
    await Promise.all([this.loadRateCards(), this.loadServiceLevels(), this.loadPalletTypes()]);
  },
  computed: {
    cheapest(): { network: string, name: string, cost: number } | null {
      const filteredRateCards = this.chosenRateCards.filter((rc) => rc.cost !== null)
      if (filteredRateCards.length === 0) {
        return null;
      }
      const cheapest = filteredRateCards.reduce((acc, rc) => rc.cost! < acc.cost! ? rc : acc, filteredRateCards[0]);
      const rateCard = this.rateCards.find((rc) => rc.name === cheapest.rateCard)!;
      return {
        network: rateCard.network,
        name: rateCard.name,
        cost: cheapest.cost!,
      }
    }
  },
  methods: {
    async loadRateCards() {
      const response = await axios.get<{ rateCards: RateCard[] }>(RATE_CARDS_URL);
      this.rateCards = response.data.rateCards.sort((a, b) => a.name.localeCompare(b.name));
    },
    async loadServiceLevels() {
      const response = await axios.get<{ serviceLevels: ServiceLevel[] }>(SERVICE_LEVELS_URL);
      this.serviceLevels = response.data.serviceLevels.sort((a, b) => a.name.localeCompare(b.name));
      this.service = this.serviceLevels[0].name;
    },
    async loadPalletTypes() {
      const response = await axios.get<{ palletTypes: PalletType[] }>(PALLET_TYPES_URL);
      this.palletTypes = response.data.palletTypes.map((pt) => (
          {
            ...pt,
            count: 0,
          }
      ));
    },
    addRateCard() {
      this.chosenRateCards.push({ rateCard: null, cost: null });
    },
    removeRateCard(index: number) {
      this.chosenRateCards.splice(index, 1);
    },
    async getPrices() {
      const filteredPalletTypes = this.palletTypes.filter((pt) => pt.count > 0);
      const filteredRateCards = this.chosenRateCards.filter((rc) => rc.rateCard !== null);
      if (!POSTCODE_REGEX.test(this.postcode) || filteredPalletTypes.length === 0 || filteredRateCards.length === 0) {
        this.chosenRateCards.forEach((rc) => rc.cost = null);
        return;
      }
      const params: { [key: string]: any } = {
        service: this.service,
        postcode: this.postcode,
        rate_card: filteredRateCards.map((rc) => rc.rateCard!),
      };
      for (const pt of filteredPalletTypes) {
        params[`${pt.shortCode}_pallets`] = pt.count;
      }
      const response = await axios.get<{ [rateCard: string]: string | null }>(PRICING_URL, {
        params: params
      });
      for (const rc of filteredRateCards) {
        const cost = response.data[rc.rateCard!];
        rc.cost = cost === null ? null : parseFloat(cost)
      }
    }
  },
  watch: {
    async service() {
      await this.getPrices();
    },
    async postcode() {
      await this.getPrices();
    },
    palletTypes: {
      deep: true,
      async handler() {
        await this.getPrices();
      }
    },
    chosenRateCards: {
      deep: true,
      async handler() {
        await this.getPrices();
      }
    },
  }
})
